import api from './api';

const subscriptionService = {
  // Plans
  getPlans: () => api.get('/subscription/plans'),
  createPlan: (data) => api.post('/subscription/plans', data),
  updatePlan: (id, data) => api.put(`/subscription/plans/${id}`, data),
  deletePlan: (id) => api.delete(`/subscription/plans/${id}`),

  // Subscriptions
  getAllSubscriptions: (params) => api.get('/subscription/all', { params }),
  getStats: () => api.get('/subscription/stats'),
  grantSubscription: (data) => api.post('/subscription/grant', data),

  // Payments
  getAllPayments: (params) => api.get('/payment/all', { params }),
  getPaymentStats: () => api.get('/payment/stats'),
};

export default subscriptionService;
